import React from 'react';
import './styling.css';

function DropdownComponent({ question, value, onChange }) {
  const options = (question.Options || '')
    .split(',')
    .map((opt) => opt.trim())
    .filter(Boolean);
  return (
    <div className="shared-padding dropdown-container">
      <label className="dropdown-label">
        {question.Text}
        {question['Required?'] &&
          question['Required?'].toLowerCase() === 'yes' && (
            <span className="dropdown-required">*</span>
          )}
      </label>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className="dropdown-select"
      >
        <option value="" disabled>
          Select...
        </option>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
}

export default DropdownComponent;
